import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-dialog-upload-queued',
    templateUrl: './dialog-upload-queued.component.html',
    styleUrls: ['./dialog-upload-queued.component.scss'],
    standalone: false
})
export class DialogUploadQueuedComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: { task_id?: string }) {}
}
